class SingleTypes {
    constructor() {
        this.singleTypes = document.querySelector(".single-types");
        if (!this.singleTypes) {
            return;
        }
        this.buildLightbox();
    }

    buildLightbox(){
        lightGallery(document.querySelector('.grid-gallery'), {
            speed: 500,
            selector:"a",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001'
        });
    }
}